import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

/** POST /api/Partner/AddPartner -> PartnerRequest */
export interface PartnerRequest {
  partnerName?: string | null;
  contactPerson?: string | null;
  email?: string | null;
  phone?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  pincode?: string | null;
  username?: string | null;
  password?: string | null;
  roleIds?: number[] | null;
  /** Where the partner's OTP / password / messages are delivered (PartnerMessageType). */
  isWhatsApp?: boolean;
  isSMS?: boolean;
  isEmail?: boolean;
}

/** POST /api/Partner/UpdatePartner -> UpdatePartnerRequest (contact details only). */
export interface UpdatePartnerRequest {
  id: number;
  partnerName?: string | null;
  contactPerson?: string | null;
  email?: string | null;
  phone?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  pincode?: string | null;
}

/** POST /api/Partner/VerifyPartner -> VerifyPartnerRequest */
export interface VerifyPartnerRequest {
  partnerId: number;
  otp: number;
}

@Injectable({ providedIn: 'root' })
export class PartnerService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/Partner`;

  getAll() {
    return this.http.get(`${this.baseUrl}/GetAll`);
  }

  getById(id: number) {
    return this.http.get(`${this.baseUrl}/GetById`, { params: { id } });
  }

  /** Indicative next partner code; does not consume the counter. */
  previewPartnerCode() {
    return this.http.get(`${this.baseUrl}/PreviewPartnerCode`);
  }

  addPartner(partner: PartnerRequest) {
    return this.http.post(`${this.baseUrl}/AddPartner`, partner);
  }

  updatePartner(body: UpdatePartnerRequest) {
    return this.http.post(`${this.baseUrl}/UpdatePartner`, body);
  }

  verifyPartner(body: VerifyPartnerRequest) {
    return this.http.post(`${this.baseUrl}/VerifyPartner`, body);
  }
}
